// src/features/services/media/hooks/stateGuards.ts
export function debounce<T extends (...a: any[]) => void>(fn: T, ms = 200) {
  let to: any = null;
  return (...args: Parameters<T>) => {
    if (to) clearTimeout(to);
    to = setTimeout(() => fn(...args), ms);
  };
}
export function setOnce<T>(setter: (v: T) => void, value: T) {
  let done = false;
  return () => { if (!done) { done = true; setter(value); } };
}
// Kill any runaway timers tied to autoplay / scope swaps
export function clearAutoplayTimers() {
  const arr: any[] = (window as any).__mediaAutoplayTimers || [];
  while (arr.length) {
    const id = arr.pop();
    try { clearTimeout(id); } catch {}
    try { clearInterval(id); } catch {}
  }
  (window as any).__mediaAutoplayTimers = [];
}
export {};